import React, {useEffect, useState} from 'react'
// import env from 'react-dotenv'
export default function Display() {
    const [news, setNews] = useState({})
    
    
    useEffect(()=>{
       // console.log(news)
    },[news])

    useEffect(() => {
        getter(); // Fetch news data when component mounts
    }, []); // Empty dependency array ensures useEffect runs only once

    const getter = async() => {
        try {
            const item = await fetch(  `${process.env.REACT_APP_API_URL}/getNewsImages/65574dd5a350999fe1720dc9`);
            const data = await item.json();
            setNews(data);
        } catch (error) {
            console.error("Error fetching news:", error);
        }
    }

    return (
        <>
        {/* <div style={{padding:"20% 20% 20% 20%"}}dangerouslySetInnerHTML={{ __html: news.postBody }}></div> */}
        <img src={news} alt="news image" />
    </>
    );
}
